const tenantConfigs = {
    default: {
        appName: 'Gestionale interventi',
        enableLang: false,
        enableNotification: false,
        insertClientInStamping: false,
        fieldImportoPagatoEnabled: false,
        enableLogForAdmin: false,
        strLogoutError: 'Logout non possibile...',
        maxMaterialsNumber: 30,
        strInBadge: 'Inserisci...',
        strOutBadge: 'Termina...',
        enablePriceMandatoryAssistance: false,
        enableClientEditingAssistance: false,
        forceToggleMenu: false,
        enableClientLog: false,
        company: "Super Mario Inc.",
        slogan: "Applied Hydraulics",
        mail: "stefanofra@gmail.com",
        since: "2024-02-01T20:00:00",
        icon: "plumber.svg"
    },
    tenant_1: {
        appName: 'Gestionale interventi - PEP',
        enableLang: false,
        enableNotification: false,
        insertClientInStamping: false,
        fieldImportoPagatoEnabled: false,
        enableLogForAdmin: false,
        strLogoutError: 'Logout non possibile...',
        maxMaterialsNumber: 30,
        strInBadge: 'Timbra entrata',
        strOutBadge: 'Timbra uscita',
        enablePriceMandatoryAssistance: false,
        enableClientEditingAssistance: true,
        forceToggleMenu: true,
        enableClientLog: true,
        company: "Progetto Energia s.r.l.",
        slogan: "Impianti & Energia",
        mail: "info@progettoenergiasrl.it",
        since: "2024-11-23T20:00:00",
        icon: "pep.svg"
    },
    tenant_1000: {
        appName: 'Gestionale interventi - DEMO',
        enableLang: false,
        enableNotification: false,
        insertClientInStamping: false,
        fieldImportoPagatoEnabled: false,
        enableLogForAdmin: false,
        strLogoutError: 'Logout non possibile...',
        maxMaterialsNumber: 30,
        strInBadge: 'Timbra entrata',
        strOutBadge: 'Timbra uscita',
        enablePriceMandatoryAssistance: false,
        enableClientEditingAssistance: true,
        forceToggleMenu: true,
        enableClientLog: true,
        company: "Super Mario Inc.",
        slogan: "Applied Hydraulics",
        mail: "stefanofra@gmail.com",
        since: "2024-02-01T20:00:00",
        icon: "plumber.svg"
    },
    tenant_1001: {
        appName: 'Gestionale interventi',
        enableLang: false,
        enableNotification: false,
        insertClientInStamping: false,
        fieldImportoPagatoEnabled: false,
        enableLogForAdmin: false,
        strLogoutError: 'Logout non possibile...',
        maxMaterialsNumber: 30,
        strInBadge: 'Inserisci...',
        strOutBadge: 'Termina...',
        enablePriceMandatoryAssistance: false,
        enableClientEditingAssistance: false,
        forceToggleMenu: false,
        enableClientLog: false,
        company: "Super Mario Inc.",
        slogan: "Applied Hydraulics",
        mail: "stefanofra@gmail.com",
        since: "2024-02-01T20:00:00",
        icon: "plumber.svg"
    },
};
export default tenantConfigs;
